<div class="form-group">
	<div class="row">
		<h6 class="col-sm-3 control-label">{{ 'adminstat.filterForm.userRegSource' | translate }}</h6>
		<div class="col-sm-3">
			<select class="form-control" (change)="getData()" [(ngModel)]="userRegSource" [ngModelOptions]="{standalone: true}">
			<option *ngFor="let opt of ['', 'ukitAlt']" value="{{opt}}" [selected]="opt == userRegSource">
				{{ opt }}
			</option>
			</select>
		</div>
		<div class="col-sm-6"></div>
	</div>
</div>

<table class="table table-sm">
	<thead>
	<tr>
		<th>{{ 'adminstat.users.live.created (Moscow)' | translate }}</th>
		<th>{{ 'adminstat.common.Username' | translate }}</th>
		<th>{{ 'adminstat.common.Email' | translate }}</th>
		<th>{{ 'adminstat.filterForm.regFilter' | translate }}</th>
		<th>{{ 'adminstat.common.referer' | translate }}</th>
		<th>{{ 'adminstat.filterForm.site' | translate }}</th>
	</tr>
	</thead>

	<tbody>
	<tr *ngFor="let row of rows;">
		<td style="white-space: nowrap;">
			<small>{{row.created}}</small>
		</td>
		
		<td>{{row.username}}</td>
	
		<td><gotosupport [value]="row.email"></gotosupport></td>
	
		<td>{{row.regType}}</td>
	
		<td>{{row.referer}}</td>
	
		<td><span [class]="row.isUpdated ? 'badge badge-warning' : 'badge'"><a target="_blank" rel="noreferrer" href="http://{{row.firstSiteDomain}}">{{row.firstSiteDomain}}</a></span></td>
	</tr>
	</tbody>
</table>

<loading [isLoad]="listLoader"></loading>
